/*
 * @Author: hong.zhang
 * @Date: 2021-04-09 17:11:44
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-08-18 17:25:44
 * @Description: 
 */
import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
// import CacheRoute from 'react-router-cache-route'
// import MerchantSettled from '../views/merchant-settled'

const renderRoutes = (routes: any, outerProps = {}) => {
  return routes ? (
    <Switch>
      {/* {
        routes.filter((route: any, i: any) => (
          route.component === 'MerchantSettled' ? (  
            <CacheRoute exact path="/merchant-settled" component={MerchantSettled} when="always" /> 
          ) : null
        ))}  */}
      {routes
        .filter((route: any) => route.redirect)
        .map((route: any, i: any) => (
          <Redirect
            key={i}
            exact={true}
            from={route.path}
            to={route.redirect}
          />
        ))}
      {routes.map((route: any, i: any) => {
        return route.component ? (
          <Route
            key={i}
            path={route.path}
            exact={route.exact ? true : false}
            render={(props) => {
            document.title = route.title || "Carlcare"
             return <route.component
                {...props}
                {...outerProps}
                routes={route.routes}
                currentMenuItem={route}
              />
            }}
          />
        ) : (
          <Redirect key={100000} exact={true} to={"/error"} />
        );
      })}
    </Switch>
  ) : null;
};

export { renderRoutes };
